'use strict'

const is_sp = ".iphone, .ipod, .ipad, .android, .windowsphone"
const is_pc = ".win, .mac, .linux"

export default {
  break: 787,
  uaset: {
    sp: is_sp,
    pc: is_pc
  },
  uacheck: (comp) => {
    if( $("html").is(is_sp) ){
      comp.mode = "sp"
    } else {
      comp.mode = "pc"
    }
  }
}



// WEBPACK FOOTER //
// ./_src/js/vars.js